import React, {useEffect} from 'react';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import {NZPostTheme} from '@nzpost/react-components';
import ReactGA from "react-ga4";
import WizardPage from './WizardPage';
import SuccessPage from './SuccessPage';
import '@nzpost/react-components/dist/index.css'
import './App.css';

let path = window.location.pathname;
if (path.lastIndexOf('/') !== path.length-1) {
  path = path + '/';
}
//Uncomment the line below to test localhost from /
// path = "/"

class DebugRouter extends BrowserRouter {
  constructor(props) {
    super(props);
    console.log('initial history is: ', JSON.stringify(this.history, null,2))
    this.history.listen((location, action)=> {
      console.log(
        `The current URL is ${location.pathname}${location.search}${location.hash}`
      )
      console.log(`The last navigation action was ${action}`, JSON.stringify(this.history, null,2));
    });
  }
}

const App = () => {

  useEffect(() => {
    //Initialize GA
    ReactGA.initialize(process.env.REACT_APP_GA_ID );
  }, []);

  return (
    <NZPostTheme>
      <DebugRouter basename={path}>
        <Switch>
          <Route exact path="/" component={WizardPage}/>
          <Route exact path='/success/:orderReference' component={SuccessPage} />
          <Redirect to={path} />
        </Switch>
      </DebugRouter>
    </NZPostTheme>
  );
}

export default App;
